import { Component } from "react";

class CheckConfigField extends Component {
	constructor(props) {
		super(props);

		this.handleChange = this.handleChange.bind(this);
	}

	handleChange(event) {
		const value = event.target.value.trim();
		if (this.props.changeCallback) {
			this.props.changeCallback(value);
		}
	}

	render() {
		const {fieldName, fieldType, fieldLabel, fieldValue} = this.props;
		return (
			<p className="check-config-field">
				<label htmlFor={fieldName}>{fieldLabel}</label>
				<input type={fieldType} id={fieldName} onChange={this.handleChange} value={fieldValue || ''} />
			</p>
		)
	}
}

export default CheckConfigField;